<template>
  <div :class="$style.container">
    <!-- <spa-updater></spa-updater> -->
    <notifications-loader></notifications-loader>
    <header>
      <header-top :hasNav="hasNav" />
      <OngoingMeetings v-if="showOngoingMeeting" :limit="1" />
      <header-bottom v-if="hasNav" />
    </header>
    <slot></slot>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import installPusher from '@/plugins/pusher'
  import { NotificationsLoader } from 'vue-components/notifications'
  import HeaderTop from './header-top/header-top'
  import HeaderBottom from './header-bottom/header-bottom'
  import OngoingMeetings from '@/components/shared/OngoingMeetings'
  // import SpaUpdater from '@/components/spa-updater/spa-updater'

  const { mapState: mapGlobalState } = createNamespacedHelpers('global')

  export default {
    components: {
      NotificationsLoader,
      HeaderTop,
      HeaderBottom,
      OngoingMeetings,
      // SpaUpdater
    },
    props: {
      hasNav: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapGlobalState([
        'ongoingActivities'
      ]),
      showOngoingMeeting () {
        return this.hasNav &&
          this.ongoingActivities.length > 0 &&
          (this.$route.name !== 'meeting' || this.$route.params.id !== this.ongoingActivities[0].id)
      }
    },
    created () {
      installPusher()
    }
  }
</script>

<style module lang="less" src="./logged-in-layout.less"></style>



// WEBPACK FOOTER //
// logged-in-layout.vue?c37684ea